export default {
  message: {
    hello: 'bonjour monde'
  }
}
